/**
 * The `&clip_result=` query fragment for a Clip Result filter value, or ""
 * when the filter should not narrow the request.
 *
 * The Clip Result dropdown offers "All", but the clip list and report
 * endpoints only accept Verified, Unverified, Faulted and Unprocessed
 * (actuate_admin `ClipParamSerializer.clip_result`); `clip_result=All` is a
 * 400. "All" therefore means "no filter", the same as a blank dropdown.
 */
export const clipResultParam = (clipResult: string | null | undefined) => {
  if (!clipResult || clipResult === "All") return "";
  return `&clip_result=${encodeURIComponent(clipResult)}`;
};
